const config = require('core/config'),
	WORDSMYTH_BASE = (config.resources.media.cdn || config.resources.media.origin) + '/ws/',
	WORDSMYTH_SOUND_BASE = WORDSMYTH_BASE + 'sound/wedt/',
	_ = require('underscore'),
	userContext = require('core/userContext');

function ReadWorksProduct(product) {
	for (var key in product) {
		this[key] = product[key];
	}
}

ReadWorksProduct.prototype = {
	getGrades: function () {
		var grades = this.grades;

		if (!grades && this.articles) {
			grades = [];

			_.each(this.articles, function (article) {
				var gradesForArticle = article.grades;

				if (gradesForArticle) {
					gradesForArticle.forEach(function (gradeForArticle) {
						if (grades.indexOf(gradeForArticle) === -1) {
							grades.push(gradeForArticle);
						}
					});
				}
			});
		}

		return grades;
	},

	/**
	 * Return a clone of the question set's questions
	 * if expressOnly is true, and an express set is defined, filter
	 * the set to only those questions.
	 *
	 * @param {number} questionSetId
	 * @param {boolean} expressOnly
	 */
	getQuestions(questionSetId, expressOnly) {
		const qset = this.questionSets[questionSetId];
		let questions = $.extend(true, [], qset.questions);
		let abridgedIds = qset.abridged_question_ids || [];
		abridgedIds = abridgedIds.reduce((lookup, id) => {
			lookup[id] = true;
			return lookup;
		}, {});

		if (expressOnly && qset.abridged_question_ids) {
			questions = questions.filter(q => abridgedIds[q.qid]);
		}

		return questions;
	},

	hasAnswerKey: function (questionSetId) {
		var questionSets = this.questionSets;

		if (questionSets) {
			if (typeof questionSetId !== 'undefined' && questionSetId !== null) {
				questionSets = {
					[questionSetId]: questionSets[questionSetId]
				};
			}

			for (var qsId in questionSets) {
				var questionsForQuestionSet = questionSets[qsId].questions;

				for (var i = 0, l = questionsForQuestionSet.length; i < l; i++) {
					var question = questionsForQuestionSet[i];

					if (question.answers && question.answers.length) {
						return true;
					}
				}
			}
		}

		return false;
	},

	hasAudio: function () {
		if (this.audio) {
			return true;
		} else if (this.articleList && this.articleList.length) {
			let list = this.articleList;
			return list.every(a => a.audio || a.video);
		}
		return false;
	},

	hasExperiment: function () {
		return typeof this.experiments !== 'undefined';
	},

	getVersionForExperiment: function () {
		return this.experiments[userContext.getExperimentGroup(Object.keys(this.experiments).length).toLowerCase()];
	},

	wordAudioUrl: function (word) {
		const senseIds = Object.keys((this.vocab && this.vocab.support.senses) || {});
		let url = null;
		senseIds.forEach(senseId => {
			const sense = this.vocab.support.senses[senseId];
			if (sense.word === word) {
				url = WORDSMYTH_SOUND_BASE + sense.pronunciation;
			}
		});
		return url;
	},

	getAllWordAudioUrls() {
		const senseIds = Object.keys((this.vocab && this.vocab.support.senses) || {});
		let urlMap = senseIds
			.map(senseId => {
				const sense = this.vocab.support.senses[senseId];
				return WORDSMYTH_SOUND_BASE + sense.pronunciation;
			})
			.reduce((acc, u) => {
				//deduplicate
				acc[u] = true;
				return acc;
			}, {});
		return Object.keys(urlMap || {});
	}
};

module.exports = ReadWorksProduct;
